var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoyaltyPointsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9091)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9091",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 8.8125L12.75 11.4375L13.375 15.1875L10 13.375L6.625 15.125L7.25 11.375L4.5625 8.75L8.3125 8.1875L10 4.8125L11.6875 8.1875L15.4375 8.8125ZM18.125 9.375C17.75 9.375 17.5 9.625 17.5 10C17.5 10.375 17.75 10.625 18.125 10.625C18.5 10.625 18.75 10.375 18.75 10C18.75 9.625 18.5 9.375 18.125 9.375ZM17.4375 8.9375C17.625 8.8125 17.875 8.75 18.125 8.75C18.3125 8.75 18.5 8.8125 18.6875 8.875C18.1875 4.9375 15.0625 1.8125 11.125 1.3125C11.1875 1.5 11.25 1.6875 11.25 1.875C11.25 2.125 11.1875 2.375 11.0625 2.5625C14.3125 3.0625 16.9375 5.625 17.4375 8.9375ZM17.4375 11C16.9375 14.6875 13.8125 17.5 10 17.5C6.1875 17.5 3.0625 14.6875 2.5625 11.0625C2.375 11.1875 2.125 11.25 1.875 11.25C1.6875 11.25 1.5 11.1875 1.3125 11.125C1.875 15.4375 5.5625 18.75 10 18.75C14.4375 18.75 18.125 15.4375 18.6875 11.125C18.5 11.1875 18.3125 11.25 18.125 11.25C17.875 11.25 17.625 11.1875 17.4375 11ZM1.875 10.625C2.1875 10.625 2.5 10.3125 2.5 10C2.5 9.6875 2.1875 9.375 1.875 9.375C1.5625 9.375 1.25 9.6875 1.25 10C1.25 10.3125 1.5625 10.625 1.875 10.625ZM2.5625 8.9375C3 5.625 5.625 3.0625 8.9375 2.5625C8.8125 2.375 8.75 2.125 8.75 1.875C8.75 1.6875 8.8125 1.5 8.875 1.3125C4.9375 1.8125 1.8125 4.9375 1.3125 8.875C1.5 8.8125 1.6875 8.75 1.875 8.75C2.125 8.75 2.375 8.8125 2.5625 8.9375ZM10 2.5C10.375 2.5 10.625 2.25 10.625 1.875C10.625 1.5 10.375 1.25 10 1.25C9.625 1.25 9.375 1.5 9.375 1.875C9.375 2.25 9.625 2.5 10 2.5Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoyaltyPointsAlt);
export default __webpack_public_path__ + "static/media/icon-loyalty-points-alt.f3318a89c2fe6b7dfda2e3804a52a68d.svg";
export { ForwardRef as ReactComponent };